import { render, staticRenderFns } from "./FooterDefault.vue?vue&type=template&id=657a86b6&scoped=true&"
import script from "./FooterDefault.vue?vue&type=script&lang=js&"
export * from "./FooterDefault.vue?vue&type=script&lang=js&"
import style0 from "./FooterDefault.vue?vue&type=style&index=0&id=657a86b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "657a86b6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/royalbeeseg.com/Demo-4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('657a86b6')) {
      api.createRecord('657a86b6', component.options)
    } else {
      api.reload('657a86b6', component.options)
    }
    module.hot.accept("./FooterDefault.vue?vue&type=template&id=657a86b6&scoped=true&", function () {
      api.rerender('657a86b6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/partial/footers/FooterDefault.vue"
export default component.exports